import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const HygieneTableColumnsModel: ITableColumn[] = [
  {
    labelPath: 'hygienePage.gridColumns.violationName',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.TextWithIconAndTooltip,
    width: 300,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'violationName',
    iconSrc: 'iconSrcViolationName',
    tooltipIconText: 'toolTipViolationName',
  },
  {
    labelPath: 'hygienePage.gridColumns.resourceName',
    propertyKey: 'resourceName',
    colType: TableColumnTypeEnum.Text,
    width: 280,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'resourceName',
    descriptionLabelPath: 'commonEntitiesInfo.resourceName',
  },
  {
    labelPath: 'hygienePage.gridColumns.owasp',
    propertyKey: 'owasp',
    colType: TableColumnTypeEnum.Text,
    width: 200,
    widthType: WidthType.Pixel,
    toCapitalize: true,
    isSortable: true,
    sortKey: 'owasp',
  },
  {
    labelPath: 'hygienePage.gridColumns.resourceType',
    propertyKey: 'resourceType',
    colType: TableColumnTypeEnum.Text,
    width: 108,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'resourceType',
    descriptionLabelPath: 'commonEntitiesInfo.resourceType',
  },
  {
    labelPath: 'hygienePage.gridColumns.ruleTags',
    propertyKey: 'ruleTags',
    colType: TableColumnTypeEnum.Tag,
    width: 182,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'hygienePage.gridColumns.createdBy',
    propertyKey: 'createdBy',
    colType: TableColumnTypeEnum.TextOrNA,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'createdByName',
    descriptionLabelPath: 'commonEntitiesInfo.createdBy',
  },
  {
    labelPath: 'hygienePage.gridColumns.ownedBy',
    propertyKey: 'ownedBy',
    colType: TableColumnTypeEnum.MultiValueOrNA,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: false,
    descriptionLabelPath: 'commonEntitiesInfo.ownedBy',
  },
  {
    labelPath: 'hygienePage.gridColumns.severity',
    propertyKey: 'severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 126,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'severity',
  },
  {
    labelPath: 'violationsPage.gridColumns.labels',
    propertyKey: 'labels',
    colType: TableColumnTypeEnum.Label,
    width: 116,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'hygienePage.gridColumns.firstSeen',
    propertyKey: 'firstSeen',
    colType: TableColumnTypeEnum.Date,
    width: 124,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'firstSeen',
  },
  {
    labelPath: 'hygienePage.gridColumns.violationStatus',
    propertyKey: 'statusLabel',
    colType: TableColumnTypeEnum.StatusLabel,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'status',
  },
  {
    labelPath: 'hygienePage.gridColumns.resourceStatus',
    propertyKey: 'resourceStatusLabel',
    colType: TableColumnTypeEnum.StatusLabel,
    isSortable: true,
    sortKey: 'resourceStatus',
    width: 150,
    widthType: WidthType.Pixel,
  },
];
